module.exports = __webpack_public_path__ + "static/media/coronavirus-low-opacity.724e8322.svg";